module.exports = __webpack_public_path__ + "static/media/Theme2.81baa8e6.png";